import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { isGuestToken } from 'common/hook/useIsGuest';
import { handleException } from 'modules/account/detail/helpers/utils';
import { Client } from 'modules/account/types';

/**
 * Lấy danh sách đơn vị là khách hàng
 *
 * @param options.type Loại đơn vị: 1 - cũ , 2 - mới (kios)
 */
const useGetListClients = (options?: { type?: 1 | 2 }) => {
  const { type } = options || {};
  const service = useService();
  return useQuery({
    queryKey: [KEYS_QUERY.clients, type],
    queryFn: async () => {
      try {
        if (!service) return [] as Client[];
        const res = await service.KiosController_listClients({
          queries: type ? { type } : undefined,
        });
        return res;
      } catch (error) {
        handleException(error);
        return [] as Client[];
      }
    },
    staleTime: 1000 * 30,
    // Khách bị BE chặn endpoint /external/kios/client (403 GUEST_FORBIDDEN); tắt query ở đây để
    // chặn lỗi cho MỌI màn dùng hook này (không riêng Dashboard), tránh queryCache.onError bật
    // snackbar lỗi toàn cục ngay khi khách vào trang.
    enabled: !!service && !isGuestToken(),
  });
};

export default useGetListClients;
